import {
  LayoutDashboard,
  BookOpen,
  Megaphone,
  MessageSquare,
  Award,
  TrendingUp,
  Sparkles,
  GraduationCap,
} from "lucide-react";
import type { SidebarSectionConfig } from "./userSidebarConfig";

/**
 * Instructor sidebar — surfaces the instructor-only routes that previously had
 * no entry point. Mirrors the admin/user shape so it can be merged by
 * DashboardShell when a user holds the `instructor` role.
 */
export const instructorSidebarConfig: SidebarSectionConfig[] = [
  {
    labelKey: "sidebar.sections.teaching",
    items: [
      { to: "/instructor/dashboard", icon: LayoutDashboard, labelKey: "sidebar.instructor.dashboard", end: true },
      { to: "/admin/courses", icon: BookOpen, labelKey: "sidebar.instructor.courses" },
      { to: "/instructor/bootcamps", icon: GraduationCap, labelKey: "sidebar.instructor.bootcamps" },
      { to: "/instructor/announcements", icon: Megaphone, labelKey: "sidebar.instructor.announcements" },
      { to: "/instructor/feedback", icon: MessageSquare, labelKey: "sidebar.instructor.feedback" },
      { to: "/instructor/certificates", icon: Award, labelKey: "sidebar.instructor.certificates" },
    ],
  },
  {
    labelKey: "sidebar.sections.instructorInsights",
    items: [
      { to: "/learning-analytics", icon: TrendingUp, labelKey: "sidebar.instructor.learningAnalytics" },
      { to: "/settings/ai", icon: Sparkles, labelKey: "sidebar.instructor.aiSettings" },
    ],
  },
];
